import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';

interface IProps {
  label: string;
  bgColor?: string;
}

const StyledSpan: StyledFunction<{ bgColor?: string } & React.HTMLProps<HTMLInputElement>> = styled.span;
const Label = StyledSpan`
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  background-color: ${props => props.bgColor || 'inherit'};
  color: ${props => (props.bgColor ? '#fff' : 'currentColor')};
  border-radius: 2px;
`;

export class RoundStateLabel extends React.PureComponent<IProps, {}> {
  public render() {
    return <Label bgColor={this.props.bgColor}>{this.props.label}</Label>;
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundStateLabel.tsx